import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const check = () => {
      const el = document.getElementById('first-cta');
      if (!el) return;
      setVisible(el.getBoundingClientRect().bottom < 0);
    };
    check();
    window.addEventListener('scroll', check, {
      passive: true
    });
    window.addEventListener('resize', check);
    return () => {
      window.removeEventListener('scroll', check);
      window.removeEventListener('resize', check);
    };
  }, []);
  return <AnimatePresence data-id="element-143" data-mp="2aus1ee1rz5ug">
      {visible && <motion.div className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 pt-2" initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-144" data-mp="2atqn80pgq38i">
          <a href={CHECKOUT_URL} className="sob-shake mx-auto flex max-w-md items-center justify-center gap-2 rounded-2xl border-b-4 border-gold-dark bg-gold px-4 py-4 text-center text-base font-extrabold uppercase tracking-wide text-ink shadow-[0_14px_34px_-8px_rgba(11,11,12,0.6)] focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/50" data-id="element-145" data-mp="2z4bmz44oa1oj">
            <span className="whitespace-nowrap" data-id="element-146" data-mp="2fcnh9vp3supq">Get the Blueprint — $27</span>
            <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-147" data-mp="2kduptwz2lxxg" />
          </a>
        </motion.div>}
    </AnimatePresence>;
}